import {
	createWalletClient,
	http,
	type defineChain,
	type WalletClient,
} from "viem";

import {
	privateKeyToAccount,
} from "viem/accounts";

import {
	chains,
} from "./const";

import {
	getConfiguredAccount,
} from "./helpers";


import type {
	HTTPURL,
	RuntimeMode,
	ValidChainId,
} from "@types";

import {
	getRPCURL,
	getAdminRPCURL,
	type Address,
} from "@bracket/chainography";

import type { Config } from "@wagmi/core";



export declare type GetViemWalletClientProps = {
	key?: Address;
	chainId?: ValidChainId;
	mode?: RuntimeMode;
	url?: HTTPURL;
	chain?: ReturnType<typeof defineChain>;
	config?: Config
	admin?: boolean;
}


export const getViemWalletClient = ({
	key,
	chainId = 1,
	mode = "PROD",
	url,
	chain,
	config,
	admin = false,
}: GetViemWalletClientProps = {}): WalletClient => {
	try {
		const account = getConfiguredAccount(key);
		if(account) {
			url = url || admin ? getAdminRPCURL<HTTPURL>(chainId) : getRPCURL(chainId);
			chain = chain || chains.get(chainId);
			if(url && chain) {
				return createWalletClient({
					account,
					chain,
					transport: http(url),
				});
			}
		}
		throw new Error("invoked getViemWalletClient without PRIVATE_WALLET_KEY present in the environment");
	}
	catch( err ) {
		throw new Error(`@bracket/contractor::getViemWalletClient - ${err.message}`)
	}
}

